import { LoadingButton } from "@mui/lab";
import {
  Button,
} from "@mui/material";
import React, {useEffect, useMemo, useState} from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {useHistory, useParams} from "react-router-dom";

import {
  PageHeader,
} from "../../../components";
import DashboardLayout from "../../../layouts/Dashboard";
import {
  workflowClinicalRequest,
  workflowWithoutDepartureRequest,
} from "../../../redux/actions";
import {
  getWithoutDepartureRequestByKey,
} from "../../../redux/actions/";
import {renderControls, RequestStateChecker} from "./../../../functions";
import {
  WithoutDepartureRequestInfoSection,
} from "./Sections";
import {withoutDepartureRequestCRUD} from "../../../http";
import {CONTRACT_REQUEST, DEPARTURE_SCHEDULE, WITHOUT_DEPARTURE_REQUEST} from "../../../routes";
import {REQUEST_STATE_ID_CREATED} from "../../../redux/constants/requestStateConstants";
import {confirmDialog} from "../../../components/Dialog/DialogDelete";
import { commentDialog } from "../../../components/Dialog/CommentDialog";

export const WithoutDepartureRequestInfo = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const dispatch = useDispatch();
  const history = useHistory()
  const [loading, setLoading] = useState(false);

  const [requestId, setRequestId] = useState(id);
  const [stateId, setStateId] = useState(0);
  const [request, setRequest] = useState({});

  const { withoutDepartureRequest } = useSelector(
    (s) => s.withoutDepartureRequest
  );

  const stateCode = withoutDepartureRequest?.state?.code?.toLowerCase();

  const state = useMemo(
      () => new RequestStateChecker(withoutDepartureRequest?.state?.code),
      [withoutDepartureRequest?.state?.code]
  );

  const handleEdit = async (e) => {
    e.preventDefault();
    console.log(request)
    await withoutDepartureRequestCRUD.edit({...request});

  };

  const handleWorkflow = async (e, nextStateId, comment) => {
    e.preventDefault();
    setLoading(true);

    if (!withoutDepartureRequest?.state?.id) return setLoading(false);

    const prevStateId = withoutDepartureRequest.state.id;

    // Updating Workflow
    const updated = await dispatch(
      workflowWithoutDepartureRequest(id, prevStateId, nextStateId, comment)
    );
    if (!updated) return;

    setStateId(nextStateId);
    setLoading(false);
  };

  const handleWorkflowDeclinedToCreate = async () => {
    setLoading(true);

    if (!withoutDepartureRequest?.state?.id) return setLoading(false);

    const prevStateId = withoutDepartureRequest.state.id;
    const nextStateId = state.getId(REQUEST_STATE_ID_CREATED);

    // Updating Workflow
    const updated = await dispatch(
        workflowWithoutDepartureRequest(requestId, prevStateId, nextStateId)
    );
    if (!updated) return setLoading(false);

    setStateId(nextStateId);
    setLoading(false);
  };


  const controls = [
    {
      state: "created",
      roles: [],
      buttons: [
        <LoadingButton
          loading={loading}
          color="primary"
          onClick={(e) => handleWorkflow(e, 2)}
        >
          Начать обработку
        </LoadingButton>,
        <Button
            color="secondary"
            onClick={handleEdit}
        >
          Сохранить
        </Button>,
        <Button
            variant={"text"}
            onClick={() => history.push(WITHOUT_DEPARTURE_REQUEST)}
        >
          Вернуться
        </Button>
      ],
    },
    {
      state: "processing",
      roles: [],
      buttons: [
        <LoadingButton
          loading={loading}
          color="primary"
          onClick={(e) => handleWorkflow(e, 4)}
        >
          Завершить
        </LoadingButton>,
        <LoadingButton color="warning" onClick={async (e) => {
          commentDialog('Изменение статуса', 'Укажите комментарий для отклонения.', async (_) => {
            await handleWorkflow(e, 5, _?.comment);
          });
        }}>
          Отклонить с комментариями
        </LoadingButton>,
        <Button
            variant={"text"}
            onClick={() => history.push(WITHOUT_DEPARTURE_REQUEST)}
        >
          Вернуться
        </Button>
      ],
    },
    {
      state: "completed",
      roles: [],
      buttons: [
        <Button
            variant={"text"}
            onClick={() => history.push(DEPARTURE_SCHEDULE)}
        >
          Вернуться
        </Button>
      ],
    },
    {
      state: "declined",
      roles: [],
      buttons: [
        <LoadingButton
            loading={loading}
            onClick={() => {
              confirmDialog('Пересоздание', 'Вы действительно хотите пересоздать заявку?', async () => {
                await handleWorkflowDeclinedToCreate()
              })
            }
            }
        >
          Пересоздать
        </LoadingButton>,
        <Button
            variant={"text"}
            onClick={() => history.push(CONTRACT_REQUEST)}
        >
          Вернуться
        </Button>
      ],
    }
  ];

  useEffect(() => {
    dispatch(getWithoutDepartureRequestByKey(requestId));
  }, [dispatch, requestId, stateId]);

  return (
    <DashboardLayout>
      <PageHeader
        heading={`Заявка без выезда №${id} ${
          stateCode ? `(${t(`dashboard.state.${stateCode}`)})` : ""
        }`}
        status={withoutDepartureRequest.state?.name}
        controls={renderControls(controls, {
          state: stateCode,
          roles: [],
        })}
      />
      <WithoutDepartureRequestInfoSection request={request} setRequest={setRequest}/>
    </DashboardLayout>
  );
};
